<template>
    <div id="index">
        <dv-full-screen-container class="bg">
            <dv-loading v-if="loading">Loading...</dv-loading>
            <div v-else class="host-body">
                <div class="d-flex jc-center">
                    <dv-decoration-10 style="width:33.3%;height:.0625rem;" />
                    <div class="d-flex jc-center">
                        <dv-decoration-8 :color="['#568aea', '#000000']" style="width:2.5rem;height:.625rem;" />
                        <div class="title">
                            <span class="title-text">百安消防数据可视化平台</span>
                            <dv-decoration-6
                                    class="title-bototm"
                                    :reverse="true"
                                    :color="['#50e3c2', '#67a1e5']"
                                    style="width:3.125rem;height:.1rem;"
                            />
                        </div>
                        <dv-decoration-8
                                :reverse="true"
                                :color="['#568aea', '#000000']"
                                style="width:2.5rem;height:.625rem;"
                        />
                    </div>
                    <dv-decoration-10 style="width:33.3%;height:.0625rem; transform: rotateY(180deg);" />
                </div>

                <!-- 第二行 -->
                <div class="d-flex jc-between px-2">
                    <div class="d-flex" style="width: 40%">
                        <div
                                class="react-right ml-4"
                                style="width: 6.25rem; text-align: left;background-color: #0f1325;"
                        >
                            <span class="react-before"></span>
                            <span class="text">设备在线时长：{{online_time}}天</span>
                        </div>
                        <div class="react-right ml-3" style="background-color: #0f1325;">
<!--                            <span class="text colorBlue">数据分析2</span>-->
                        </div>
                    </div>
                    <div style="width: 40%" class="d-flex">
                        <div class="react-left mr-3" style="background-color: #0f1325;">
<!--                            <span class="text fw-b">vue-big-zhcf_screen</span>-->
                        </div>
                        <div
                                class="react-left mr-4"
                                style="width: 6.25rem; background-color: #0f1325; text-align: right;"
                        >
                            <span class="react-after"></span>
                            <span class="text">{{date}}</span>
                        </div>
                    </div>
                </div>
                <div class="body-box">
                    <!-- 第三行数据 -->
                    <div class="content-box1">
                        <div>
                            <div class="left">
                                <dv-border-box-12>
                                    <!--所有设备-->
                                    <pieChart1
                                        :chart1_data="chartData.pie_chart1"
                                        :area_count="area_count"
                                        :modle_data="modle_data"
										:cn="cn"
                                    />
                                </dv-border-box-12>
                            </div>
                            <div class="left">
                                <dv-border-box-12>
                                    <!--消息统计-->
                                    <pieChart2
                                        :chart2_data="chartData.pie_chart2"
                                        :repair_data="repair_data"
                                    />
                                </dv-border-box-12>
                            </div>
                        </div>
                        <!-- 中间 -->
                        <div>

                            <dv-border-box-12>
                                <div>
                                    <div style="padding: 0.2rem 0 0 0.2rem">
                                        <el-switch
                                                v-model="switchValue"
                                                active-color="#5cd9e8"
                                                inactive-color="#53868B"
                                                @change="switchChange"
                                        >
                                        </el-switch>

<!--                                        <button @click="tabChange" data-id="1" class="btn">3D地图</button>-->
<!--                                        <button @click="tabChange" data-id="2" class="btn">省份分布图</button>-->
                                    </div>

                                    <h3 v-if="map_show">
                                        <DMap
                                                :location="location"
                                                :dmap-from="dmap_from"
                                                :card-data="card_data"
                                        />
                                    </h3>
                                    <h3 v-else>
                                        <centerMap
                                                :map="map1Data"
                                                :card-data="card_data"

                                        />
                                    </h3>


                                </div>

                            </dv-border-box-12>

                        </div>
                        <!-- 中间 -->

                        <div>
                            <dv-border-box-12>
                                <list
                                    :config="list_config"/>
                            </dv-border-box-12>
                        </div>
                    </div>
                    <!-- 第四行数据 -->
                    <div class="bototm-box2">
                        <dv-border-box-12 v-if="cn">
                            <!--设备报警柱状图
                            <bar1
                                    :bar1_data="chartData.bar_chart1"
                            />-->
							<!--设备设备-->
							<bar1 :config="bar_config_cn"  :cn="cn"/>
                        </dv-border-box-12>
						<dv-border-box-12 v-else>
							<bar1 :config="bar_config"  :cn="cn"/>
						</dv-border-box-12>
                       <!-- <dv-border-box-12>
                            系统报警排行 折线图
                            <line1
                                    :line1_data="chartData.line_chart1"
                            />
                        </dv-border-box-12>
						-->

                        <dv-border-box-12>
                            <!--异常设备-->
                            <errorDevice
                                    :config="alarm_list_config"
                            />
                        </dv-border-box-12>
                        <dv-border-box-12>
                            <!--离线-->
                            <offlineDevice
                                    :config="off_list_config"
                            />

                        </dv-border-box-12>
                        <dv-border-box-12>
                            <!--开阀-->
                            <openDevice
                                    :config="open_list_config"
                            />
                        </dv-border-box-12>
                        <dv-border-box-12>
                            <!--词条-->
                            <wordChart
                                    :word="word_data"
                                    :mask-image="maskImage"
                            />
                        </dv-border-box-12>
                    </div>

                </div>
            </div>
        </dv-full-screen-container>
    </div>
</template>

<script>
  import centerMap from "../components/echart/map/map1";
  import DMap from "../components/echart/map/DMap";
  import list from "./zhcf_screen/list";
  //import line1 from "./zhcf_screen/line1";
  import bar1 from "./zhcf_screen/bar1";
  import pieChart1 from './zhcf_screen/pie-echart1'
  import pieChart2 from './zhcf_screen/pie-echart2'
  import errorDevice from './zhcf_screen/errorDevice'
  import offlineDevice from './zhcf_screen/offlineDevice'
  import openDevice from './zhcf_screen/openDevice'
  import wordChart from './zhcf_screen/wordChart'
  import axios from 'axios'
  export default {
    data() {
      return {
        switchValue: true,
        loading: true,
        admin_id: '',
        chartData: [],
        list_config: [],
        alarm_list_config: [],
		bar_config:[],
		bar_config_cn:[],
		cn:0,
        off_list_config: [],
        open_list_config: [],
        location: [],
        map1Data: [],
        area_count: [],
        online_time: 0,
        word_data: [],
        date:'',//当前时间
        tab:1,
        map_show: true,
        dmap_from: [],
        modle_data: [],
        repair_data: [],
        card_data: [],
        maskImage: ''
      };
    },
    components: {
      centerMap,
      list,
      bar1,
      pieChart1,
      pieChart2,
      errorDevice,
      offlineDevice,
      openDevice,
      wordChart,
      DMap
    },
    mounted() {
      var maskImage = new Image();
      maskImage.src = "data:image/png;base64,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"
      this.maskImage = maskImage
      this.fetchList()
      setInterval(this.getTime, 1000)
      let time = 1000 * 60 * 30 //每30分钟
      setInterval(this.fetchList, time) //一小时刷新一次
      this.getWord()
      setInterval(this.getWord,  1000 * 60 * 2) //2min刷新一次
    },
    methods: {
      tabChange(e){
        let tabs = e.target.dataset.id
        this.tab = tabs
        if (this.tab == 1){
          this.map_show = true
        }else{
          this.map_show = false
        }
      },
      getWord(){
        this.word_data = [
          {'name': '福建泉州', value: 5},
          {'name': '英都镇', value: 1},
          {'name': '消防产品', value: 1},
          {'name': '阀门', value: 1},
          {'name': '抗震支吊架', value: 1},
          {'name': '综合管廊', value: 1},
          {'name': '开发', value: 1},
          {'name': '生产', value: 1},
          {'name': '销售', value: 1},
          {'name': '安装', value: 1},
          {'name': '服务', value: 1},
          // {'name': '百安消防科技有限公司', value: 1},
          // {'name': '福建星火阀门有限公司', value: 1},
          // {'name': '厦门斯泰普工程科技有限公司', value: 1},
          // {'name': '山东百安消防工程有限公司', value: 1},
          {'name': 'ISO9001', value: 1},
          {'name': '质量管理', value: 1},
          {'name': '体系认证', value: 1},
          {'name': 'ISO14001', value: 1},
          {'name': '环境管理', value: 1},
          {'name': 'ISO45001', value: 1},
          {'name': '职业健康', value: 1},
          {'name': '安全管理', value: 1},
          {'name': '体系认证', value: 1},
          {'name': '武器装备', value: 1},
          {'name': '知识产权', value: 1},
          {'name': '信息化', value: 1},
          {'name': '工业化', value: 1},
          {'name': '融合', value: 1},
          {'name': '售后服务', value: 1},
          {'name': '五星级认证', value: 1},
          {'name': '阀门管道', value: 1},
          {'name': 'TS认证', value: 1},
          {'name': '工贸企业', value: 1},
          {'name': '三级安全', value: 1},
          {'name': '标准化', value: 1},
          {'name': '企业认证', value: 1},
          {'name': '湿式报警阀', value: 1},
          {'name': '末端试水', value: 1},
          {'name': '玻璃分隔', value: 1},
          {'name': '洒用水喷头', value: 1},
          {'name': '消防', value: 1},
          {'name': '软管卷盘', value: 1},
          {'name': '室外消火栓', value: 1},
          {'name': '国家标准', value: 1},
          {'name': '防盗', value: 1},
          {'name': '消火栓', value: 1},
          {'name': '加密型', value: 1},
          {'name': '智能消火栓', value: 1},
          {'name': '智能化终端', value: 1},
          {'name': '消火栓', value: 1},
          {'name': '企业标准', value: 1},
          {'name': '产品专利', value: 1},
          {'name': '发明专利', value: 1},
          {'name': '驰名商标', value: 1},
          {'name': '著名商标', value: 1},
          {'name': '知名商标', value: 1},
          {'name': '技术企业', value: 1},
          {'name': '国家高新', value: 1},
          {'name': '科技型企业', value: 1},
          {'name': '科技小巨人', value: 1},
          {'name': '福建省', value: 1},
          {'name': '领军企业', value: 1},
          {'name': '自愿性认证', value: 1},
          {'name': '智能末端', value: 1},
          {'name': '试水装置', value: 1},
          {'name': '压力式', value: 1},
          {'name': '比例混合', value: 1},
          {'name': '半固定式', value: 1},
          {'name': '泡沫灭火装置', value: 1},
          {'name': '闭式泡沫', value: 1},
          {'name': '水喷淋装置', value: 1},
          {'name': '低倍数', value: 1},
          {'name': '空气泡沫', value: 1},
          {'name': '产生器', value: 1},
          {'name': '泡沫枪', value: 1},
          {'name': '泡沫喷头', value: 1},
          {'name': '泡沫消火栓', value: 1},
          {'name': '泡沫消火栓箱', value: 1},
          {'name': '泡沫灭火剂', value: 1},
          {'name': '末端试水装置', value: 1},
          {'name': '柜式七氟丙烷', value: 1},
          {'name': '灭火装置', value: 1},
          {'name': '泡沫/水两用炮', value: 1},
          {'name': '固定式消防炮', value: 1},
          {'name': '自动跟踪置', value: 1},
          {'name': '定位射流', value: 1},
          {'name': '灭火装置', value: 1},
          {'name': '湿式报警阀', value: 1},
          {'name': '雨淋报警阀', value: 1},
          {'name': '湿式报警阀', value: 1},
          {'name': '预作用装置', value: 1},
          {'name': '水流指示器', value: 1},
          {'name': '洒水喷头', value: 1},
          {'name': '快速响应喷头', value: 1},
          {'name': '信号蝶阀', value: 1},
          {'name': '信号闸阀', value: 1},
          {'name': '消防闸阀', value: 1},
          {'name': '消防蝶阀', value: 1},
          {'name': '室外消火栓', value: 1},
          {'name': '水泵接合器', value: 1},
          {'name': '消火栓箱', value: 1},
          {'name': '消防水带', value: 1},
          {'name': '软管卷盘', value: 1},
          {'name': '室内消火栓', value: 1},
          {'name': '抗震支吊架', value: 1},
          {'name': '鸟巢', value: 1},
          {'name': '体育馆', value: 1},
          {'name': '福清核电站', value: 1},
          {'name': '水立方', value: 1},
          {'name': '大兴机场', value: 1},
          {'name': 'APEC会议中心', value: 1},
          {'name': '亚投行全球资本运营', value: 1},
          {'name': '迪士尼乐园', value: 1},
          {'name': '中兴通讯', value: 1},
          {'name': '哈尔滨站', value: 1},
          {'name': '古堡酒店', value: 1},

          {'name': '百安', value: 15},
          {'name': '消防', value: 15},
          {'name': '装置', value: 15},
          {'name': '中国', value: 15},
          {'name': '企业', value: 10},
          {'name': '产品', value: 10},
          {'name': '福建泉州', value: 5},
          {'name': '消防产品', value: 6},
          {'name': 'ISO9001', value: 6},
          {'name': '五星级认证', value: 5},
          {'name': '室外消火栓', value: 5},
          {'name': '知名商标', value: 6},
          {'name': '科技', value: 12},
          {'name': '福建省', value: 5},
          {'name': '中国驰名商标', value: 5},
          {'name': '高新技术  ', value: 5},
          {'name': '技术企业', value: 5},
          {'name': '英都镇', value: 6},

        ]

      },
      switchChange(e){
        console.log(e)
        if (e){
          this.map_show = true
        }else{
          this.map_show = false
        }
      },
      cancelLoading() {
        setTimeout(() => {
          this.loading = false;
        }, 500);
      },
      fetchList(){
        this.admin_id = this.$route.query.admin_id
        console.log(this.admin_id)

        if (this.admin_id == '' || this.admin_id == undefined){
          this.loading = false;
          return
        }else{
          axios.get('/api/Screen/getScreenAllChart?admin_id='+this.admin_id).then(res => {
            if (res.code == 0){
              return
            }
            this.chartData = res.data.data
			this.cn = this.chartData.cn
            this.list_config = {
              header: ["设备名称", "日志内容"],
              data: this.chartData.log_list,
              rowNum: 10, //表格行数
              headerHeight: 35,
              headerBGC: "#0f1325", //表头
              oddRowBGC: "#0f1325", //奇数行
              evenRowBGC: "#171c33", //偶数行
              align: ["center"]
            }
            this.alarm_list_config = {
              header: ["设备名称", "水压低", "倾斜", "电量低", "温度低"],
              data: this.chartData.alarm_list,
              rowNum: 7, //表格行数
              headerHeight: 35,
              headerBGC: "#0f1325", //表头
              oddRowBGC: "#0f1325", //奇数行
              evenRowBGC: "#171c33", //偶数行
              // index: true,
              columnWidth: [130, 90, 90, 90, 90],
              align: ["center"]

            }
            this.bar_config_cn = {
              header: ["传感器ID", "预警", "温度", "CO", "烟雾", "h2", "voc"],
              data: this.chartData.bar_chart1,
              rowNum: 7, //表格行数
              headerHeight: 35,
              headerBGC: "#0f1325", //表头
              oddRowBGC: "#0f1325", //奇数行
              evenRowBGC: "#171c33", //偶数行
              // index: true,
              columnWidth: [130, 90, 90, 90, 90,90, 90],
              align: ["center"]

            }	
            this.bar_config = {
              header: ["设备名称", "位置信息", "报警信息", "时间"],
              data: this.chartData.bar_chart1,
              rowNum: 7, //表格行数
              headerHeight: 35,
              headerBGC: "#0f1325", //表头
              oddRowBGC: "#0f1325", //奇数行
              evenRowBGC: "#171c33", //偶数行
              // index: true,
              columnWidth: [130, 90, 90, 90],
              align: ["center"]

            }		
            this.off_list_config = {
              header: ["设备名称", "离线时间"],
              data: this.chartData.off_list,
              rowNum: 7, //表格行数
              headerHeight: 35,
              headerBGC: "#0f1325", //表头
              oddRowBGC: "#0f1325", //奇数行
              evenRowBGC: "#171c33", //偶数行
              // index: true,
              // columnWidth: [200, 150],
              align: ["center"]
            }

            this.open_list_config = {
              header: ["传感器ID", "离线时间"],
              data: this.chartData.open_list,
              rowNum: 7, //表格行数
              headerHeight: 35,
              headerBGC: "#0f1325", //表头
              oddRowBGC: "#0f1325", //奇数行
              evenRowBGC: "#171c33", //偶数行
              // index: true,
              // columnWidth: [200, 150],
              align: ["center"]
            }
            this.area_count = this.chartData.area_count
            this.online_time = this.chartData.online_time


            let that = this
            this.chartData.location.forEach(function (item) {
              that.location.push([{coord: item}, {coord: [118.26982,24.992072]}])
            });
            this.dmap_from = this.chartData.location
            this.map1Data = this.chartData.area_nums

            this.modle_data = this.chartData.sumary_data.modle
            this.repair_data = this.chartData.sumary_data.repair

            this.card_data = this.chartData.card_data
            setTimeout(() => {
              this.loading = false;
            }, 500);
          })
        }

      },
      // 获取当前时间时分秒
      getTime () {
        var date=new Date();
        var year=date.getFullYear(); //获取当前年份
        var mon=date.getMonth()+1; //获取当前月份
        var da=date.getDate(); //获取当前日
        var day=date.getDay(); //获取当前星期几
        var h=date.getHours(); //获取小时
        var m=date.getMinutes(); //获取分钟
        var s=date.getSeconds(); //获取秒
        // 当分秒不足10时，前面加0
        let mm
        if (m < 10){
          mm = "0" + m;
        }else {
          mm = m;
        }
        let ss
        if (s < 10){
          ss = "0" + s;
        }else {
          ss = s;
        }
        let week
        if (day === 1){
          week = "一";
        }
        else if (day === 2){
          week = "二";
        }
        else if (day === 3){
          week = "三";
        }
        else if (day === 4){
          week = "四";
        }
        else if (day === 5){
          week = "五";
        }
        else if (day === 6){
          week = "六";
        }
        else if (day === 0){
          week = "日";
        }
        this.date = year + '年' + mon + '月' + da + '日 '
          + h + ':' + mm + ':' + ss + ' 星期' + week
      },
    }
  };
</script>

<style lang="scss">
    @import "../assets/scss/index.scss";
    .left{
        height: 3.5rem;
    }
    .btn{
        background-color: #5cd9e8;
        width: 100px;
    }
</style>
